export default {
    name: "FuelIcon",
    props: {
        gold: Boolean
    }
};
